import { useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export const useRecaptchaToken = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const getRecaptchaToken = useCallback(
    async (action: string) => {
      if (!executeRecaptcha) {
        console.warn('Recaptcha not yet available');
        return null;
      }

      try {
        const token = await executeRecaptcha(action);
        console.log('Recaptcha token:', token);
        return token;
      } catch (error) {
        console.error('Recaptcha execution failed:', error);
        return null;
      }
    },
    [executeRecaptcha]
  );

  return getRecaptchaToken;
};
